(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-accordion-anchor"] && !Shopify.designMode) return;
  try {
    
  (()=> {
    const anchorSection = $('.js-anchor-section');

    anchorSection.each(function (){
      $('.js-anchor-list').append(`<a href="#${$(this).attr('id')}" class="faq-anchor__item js-anchor-item">${$(this).data("heading")}</a>`);
    })
    
     $(".js-anchor-item").first().addClass('active');
    
    $(".js-anchor-item").click(function() {
      $(".js-anchor-item").removeClass('active')
      $(this).addClass('active')
    })
  })();

  


  } catch(e) { console.error(e); }
})();
})();
